import React, { Component } from 'react';
import { OneDigit } from './OneDigit'

export class NumberKeyboard extends Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.len = getlength(this.props.max);

        this.onDigitClick = this.onDigitClick.bind(this);


  

        this.cursor = 0;

        this.state.digits = [];

        for (var i = 0; i < this.len; i++) {
            this.state.digits.push("");
        }

        if (this.props.reverseNum !== null && this.props.reverseNum != "") {
            var l = this.props.reverseNum.length;
            for (var i = 0; i < l; i++) {
                this.state.digits[i] = " " + this.props.reverseNum[i] + " ";
            }
            this.cursor=l;
        }
        

        // this.state.value=this.props.text;
        this.onChangeText = this.onChangeText.bind(this);


        this.onChangeNumber = this.onChangeNumber.bind(this);

    }

    onDigitClick(e) 
    {
     //   console.log(this.props.reverseNum);
    //    console.log(e);
        if (e == "") {
            return;
        }

        if (e == "X" || e == " X ") {

            if (this.cursor > 0)
                this.cursor--;

            this.state.digits[this.cursor] = "";



            this.onChangeNumber();
            //        this.setState({});
            return;
        }

        if (this.cursor < this.len)
            this.state.digits[this.cursor] = " " + e + " ";
        if (this.cursor < this.len)
            this.cursor++;

        this.onChangeNumber();
        //  this.setState({});



    }

    onChangeNumber() {

        var res = 0;
        var zarib = 1;

        var reverseNum = "";
        for (var i = 0; i < this.len; i++) {
            var digit = this.state.digits[i];
            if (digit == "")
                continue;

            reverseNum = reverseNum + digit.trim();
            var num = parseInt(digit);
            res = num * zarib + res;
            zarib = zarib * 10;
        }

      //  console.log(reverseNum);

        if (typeof this.props.handleTextChange === "function") {
            this.props.handleTextChange(res, "selectedNumber");

        }


        if (typeof this.props.reverseNumberChange === "function") {
            this.props.reverseNumberChange(reverseNum);
        }

    }


    onChangeText(e) {
        //this.state.value=e.target.value;

        //      console.log(e.target.value);
        this.setState({ value: e.target.value });
        if (typeof this.props.onChange === "function")
            this.props.onChange(e.target.value, this.props.name);
    }


    componentDidMount() {
    }


    render() 
    {
       

   

        for (var i = 0; i < this.len; i++) {
            var numbers = this.state.digits.map((data) =>
                <td>
                    <OneDigit number={data} bold={true}/>
                </td>
            );
        }

        return (
            <div className="align-items-center" style={{ width: "100%" }}>


                <table style={{ float: "center", marginLeft: "auto", marginRight: "auto", float: "none" }}>
                    <tbody>
                        <tr>
                            {numbers}
                        </tr>

                    </tbody>
                </table>
                <hr />
                <table style={{ float: "center", marginLeft: "auto", marginRight: "auto", float: "none" }}>
                    <tbody>
                        <tr>
                            <td><OneDigit number=" 9 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" 8 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" 7 " onClick={this.onDigitClick} /></td>
                        </tr>
                        <tr>
                            <td><OneDigit number=" 6 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" 5 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" 4 " onClick={this.onDigitClick} /></td>
                        </tr>
                        <tr>
                            <td><OneDigit number=" 3 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" 2 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" 1 " onClick={this.onDigitClick} /></td>
                        </tr>

                        <tr>
                            <td><OneDigit number=" &nbsp;&nbsp; " /></td>
                            <td><OneDigit number=" 0 " onClick={this.onDigitClick} /></td>
                            <td><OneDigit number=" X " onClick={this.onDigitClick} /></td>
                        </tr>

                    </tbody>
                </table>
            </div>


        );
    }
}

function getlength(number) {
    return number.toString().length;
}


// WEBPACK FOOTER //
// ./src/elements/NumberKeyboard.js